import { Badge } from "react-bootstrap";

const LabelBadg = ({label,key})=>
{
    return(
        <div 
        className="workitem-label"
        style={{"--color-front":"#4a5b94","--color-text":"#ececee","--color-back":"#8baade"}}
         key={key}
        >{label}</div>
    )
}
export default LabelBadg;